import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '../components/ui/card'
import { Markdown } from '../components/ui/markdown'

import privacyEn from '../locales/legal/privacy-policy.en.md?raw'
import privacyIt from '../locales/legal/privacy-policy.it.md?raw'
import cookieEn from '../locales/legal/cookie-policy.en.md?raw'
import cookieIt from '../locales/legal/cookie-policy.it.md?raw'
import creditsEn from '../locales/legal/credits.en.md?raw'
import creditsIt from '../locales/legal/credits.it.md?raw'

/**
 * The privacy and cookie notices, and the credits the licences of what we
 * build on ask for.
 *
 * The text lives in Markdown files next to the other translations rather than
 * in the i18n JSON: it is long-form prose that has to be diffable, reviewable
 * and quotable as a whole, and legal copy squeezed into JSON string values
 * stops being either readable or reviewable.
 *
 * Bundled rather than fetched. A notice that fails to load is a notice that was
 * not given, and it has to be readable from the consent banner before the
 * visitor has agreed to anything — including, on a flaky connection, before any
 * request has succeeded.
 */
const DOCUMENTS = {
  'privacy-policy': { en: privacyEn, it: privacyIt },
  'cookie-policy': { en: cookieEn, it: cookieIt },
  credits: { en: creditsEn, it: creditsIt },
} as const

export type LegalDocument = keyof typeof DOCUMENTS

export default function LegalPage({ document: name }: { document: LegalDocument }) {
  const { i18n } = useTranslation()
  const language = i18n.language?.split('-')[0] === 'it' ? 'it' : 'en'

  return (
    <div className="mx-auto max-w-3xl py-4">
      <Card>
        <CardContent className="pt-6">
          {/* `text-sm` and the wider leading are the readability of a long legal
              text, which the shared Markdown styles size for short user copy. */}
          <Markdown className="text-sm leading-relaxed">{DOCUMENTS[name][language]}</Markdown>
        </CardContent>
      </Card>
    </div>
  )
}
